import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DataAppContext = React.createContext();

const DataApp = (props) => {
    const initialValues = { loginstatus: false, username: 'User 1', balanceAmount: 0, bgColor: 'white', sidebarOpen: true }
    const [appstate, setAppState] = useState(initialValues);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const isTokenExpired = (token) => {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Math.floor(Date.now() / 1000);
            return payload.exp < currentTime;
        } catch (error) {
            return true; // invalid token = expired
        }
    }

    const checkLogin = () => {
        const publicPages = ['/login', '/forgot-password', '/reset-password'];
        if (publicPages.includes(window.location.pathname)) return;
        let token = localStorage.getItem('jwttoken');
        if (token) {
        if (isTokenExpired(token)) {
            // Token exists but is old. Show modal.
            setShowModal(true);
        } else {
            // Token exists and is valid. 
            setAppState(prev => ({ ...prev, loginstatus: true }));
        }
    } else {
        // No token at all. Force redirect to login.
        navigate('/login');
    }
}

    useEffect(() => {
        checkLogin();
        // Background interval to catch expiration while user is idle on a page
        const interval = setInterval(checkLogin, 60000); 
        return () => clearInterval(interval);
    }, [window.location.pathname]);

    const login_user = () => {
        console.log('logging in')
        const user = localStorage.getItem('userid');
        setAppState(prev => ({ 
            ...prev, 
            loginstatus: true,
            username: user 
        }));
    }
    const logout_user = () => {
        console.log('logging out')
        localStorage.removeItem('jwttoken');
        localStorage.removeItem('userid');
        localStorage.removeItem('usertype');
        setAppState({ ...appstate, loginstatus: false });
        setShowModal(false);
        navigate('/login');
    }

    const toggleSidebar = () => {
        setAppState(prevState => ({
            ...prevState,
            sidebarOpen: !prevState.sidebarOpen
        }));
    }

    return (
        <DataAppContext.Provider value={{ appstate, login_user, logout_user, toggleSidebar }}>
            <div className='app-wrapper'>
                {props.children}

                {/* Session Expiry Modal */}
                {showModal && (
                    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content text-center p-4">
                                <div className="modal-body">
                                    <h4 className="text-danger mb-3">Session Expired</h4>
                                    <p>Your session has expired. Please log in again to continue.</p>
                                    <button 
                                        className="btn btn-primary px-5" 
                                        onClick={logout_user}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DataAppContext.Provider>
    )
}

export default DataApp;

export { DataAppContext };